module.exports = __webpack_public_path__ + "static/media/Element_3_treatments.6790e2c0.svg";